module.exports = __webpack_public_path__ + "static/media/ic_bingo.35106412.svg";